//
// MultidimensionalQuery.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../QueryBase";
import "../common/Axis";
import "../common/SortItems";
import "../common/rank/RankItems";
import "./OmitItemBase";

var MultidimensionalQuery = createModule("BIRD::MultidimensionalQuery", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::QueryBase"], EventDispatcher, [
    ,
    {
        columnTotals: 2,
        columnSubtotals: 2,
        rowTotals: 2,
        omitSubtotalItems: [1],
        rowSortItems: 1,
        axes: [1],
        columnRankItems: 1,
        detail: 2,
        rowSubtotals: 2,
        columnSortItems: 1,
        rowRankItems: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default MultidimensionalQuery;
